import React, { useEffect, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import Button from '../Button/Button';
import CustomOverlay from '../CustomOverlay';
import classes from './eventFilters.module.css';
import { BiSearchAlt2 } from 'react-icons/bi';
import { FaFilter } from 'react-icons/fa';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { getWindowWidth } from '../../CustomHooks/isMobileViewHook';
import EventsMoreFiltersModal from '../../modals/EventsMoreFiltersModal';
import DateRangeCalendar from '../DateRangeCalendar';
import LocationFiltersOverlay from '../LocationFilterOverlay';
import MapMain from '../maps/MapMain';
import { ImLocation } from 'react-icons/im';

/*eslint-disable*/
const FilterDiv = ({
  text,
  icon,
  iconRight = <MdOutlineKeyboardArrowDown className={classes.icons} />,
  className = '',
  textClassName = '',
  ...props
}) => {
  return (
    <div className={[classes.dropdownBox, className].join(' ')} {...props}>
      <div>
        {icon} <span className={[textClassName].join(' ')}>{text}</span>
      </div>
      {iconRight && iconRight}
    </div>
  );
};

function EventFilters({
  data,
  onSearch,
  filtersWrapperClass = '',
  containerClass,
  t,
  filters,
  setFilters,
  savedSearch,
  disabledSearch
}) {
  const locationRef = useRef(null);
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { eventTypes } = useSelector((state) => state?.commonReducer);

  useEffect(() => {
    if (savedSearch) {
      locationRef?.current?.updateLocation(savedSearch);
    }
  }, [savedSearch]);

  // For Popover
  const [show, setShow] = useState('');
  const [target, setTarget] = useState(null);
  const [screenWidth, setScreenWidth] = useState();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    getWindowWidth(setScreenWidth);
  }, []);
  const handleClick = (event, type) => {
    if (type) {
      setShow(type);
    } else {
      setShow('');
    }
    if (event) {
      setTarget(event.target);
    } else {
      setTarget(null);
    }
  };
  const EventTypesDropDown = () => (
    <CustomOverlay
      show={show == 'event-types'}
      target={target}
      handleClose={(e) => handleClick('', e)}
      targetElement={
        <FilterDiv
          onClick={(e) => {
            handleClick(e, 'event-types');
          }}
          text={filters?.entity?.title?.[selectedLanguage] || t('filters.eventType')}
          textClassName={'maxLine1'}
        />
      }>
      <div className={[classes.overlayBox, classes.p0].join(' ')}>
        <ul className={classes.listOptionsWithBrBtm}>
          {eventTypes?.map((item, key) => (
            <li
              key={key}
              data-selected={filters?.entity?._id == item?._id}
              onClick={() => {
                setFilters((prev) => ({
                  ...prev,
                  entity: prev?.entity?._id == item?._id ? null : item
                }));
                setShow('');
              }}>
              {item?.title?.[selectedLanguage]}
            </li>
          ))}
        </ul>
      </div>
    </CustomOverlay>
  );

  const LocationDropDown = () => (
    <CustomOverlay
      show={show == 'location'}
      target={target}
      handleClose={(e) => handleClick('', e)}
      targetElement={
        <FilterDiv
          onClick={(e) => {
            handleClick(e, 'location');
          }}
          icon={
            screenWidth <= 768 ? (
              false
            ) : (
              <ImLocation color={'var(--secondary-clr)'} className={classes.icon} />
            )
          }
          text={
            screenWidth <= 768 ? (
              <ImLocation color={'var(--secondary-clr)'} />
            ) : (
              t('filters.location')
            )
          }
        />
      }>
      <div className={[classes.overlayBox, classes.width280].join(' ')}>
        <LocationFiltersOverlay
          locationState={filters}
          setLocationState={setFilters}
          setClose={setShow}
          ref={locationRef}
        />
      </div>
    </CustomOverlay>
  );
  // { target, show, handleClick, screenWidth, t }
  const DateRangeCalendarDropDown = () => (
    <CustomOverlay
      show={show == 'date-range'}
      target={target}
      handleClose={(e) => handleClick('', e)}
      targetElement={
        <FilterDiv
          onClick={(e) => {
            handleClick(e, 'date-range');
          }}
          text={
            !!filters?.date
              ? `From ${filters?.date[0]?.startDate?.toLocaleDateString()}`
              : t('filters.dateRange')
          }
          textClassName={'maxLine1'}
        />
      }>
      <div className={[classes.overlayBox, classes.p0, classes?.minWidth300].join(' ')}>
        <DateRangeCalendar
          value={
            !!filters?.date
              ? filters?.date
              : [{ startDate: new Date(), endDate: new Date(), key: 'selection' }]
          }
          setValue={(e) => {
            setFilters((prev) => ({ ...prev, date: e }));
          }}></DateRangeCalendar>

        <Button
          className={classes?.calendarApplyBtn}
          label="Apply"
          onClick={() => {
            handleSearch();
            setShow('');
          }}
        />
      </div>
    </CustomOverlay>
  );

  const handleSearch = () => {
    onSearch && onSearch();
  };
  return (
    <Container className={`${containerClass}`}>
      <div className={[classes.filters, filtersWrapperClass].join(' ')}>
        <Row className={[classes.row, 'gx-0'].join(' ')}>
          {/* 1st Option */}

          <Col md={2} className={classes.width280}>
            <LocationDropDown />
          </Col>
          <Col md={4}>
            <MapMain
              setCoordinates={(e) => {
                setFilters((prev) => ({ ...prev, lng: e?.lng, lat: e?.lat }));
              }}
              address={filters?.address}
              setAddress={(e) => {
                setFilters((prev) => ({
                  ...prev,
                  address: e,
                  nearby: false,
                  province: null,
                  town: null,
                  neighborhood: null
                }));
              }}
              placeholder={t('filters.search')}
              type="places"
              comboRootClassName={classes?.searchInput}
              deleteIcon
            />
          </Col>
          {/* 3rd Option */}
          {screenWidth > 992 && (
            <Col md={2} className={classes.width200}>
              <EventTypesDropDown />
            </Col>
          )}
          {/* 4th Option */}
          {screenWidth > 992 && (
            <Col md={2} className={classes.width180}>
              <DateRangeCalendarDropDown />
            </Col>
          )}
          {screenWidth <= 992 && (
            <Col className={classes.minWidth170}>
              <FilterDiv
                onClick={() => {
                  setShowModal(true);
                }}
                iconRight={screenWidth <= 600 ? false : <FaFilter className={classes.icon} />}
                text={
                  screenWidth <= 600 ? <FaFilter className={classes.icon} /> : t('filters.filters')
                }
              />
            </Col>
          )}
          <Button
            variant="secondary"
            borderRadius={'9px'}
            onClick={() => {
              setShow('');
              // onSearch && onSearch();
              handleSearch();
            }}
            disabled={disabledSearch}
            className={classes.searchBtn}>
            {screenWidth <= 600 ? (
              <BiSearchAlt2 size={20} color="var(--white-clr)" />
            ) : (
              t('filters.searchBtn')
            )}
          </Button>
        </Row>
      </div>
      <style>{`
      .modal-body{
        overflow:visible;
      }
      `}</style>
      <EventsMoreFiltersModal show={showModal} setShow={setShowModal} t={t} onApply={handleSearch}>
        <Col md={12}>
          <EventTypesDropDown />
        </Col>
        {/* 4th Option */}
        <Col md={12}>
          <DateRangeCalendarDropDown />
        </Col>
      </EventsMoreFiltersModal>
    </Container>
  );
}

export default EventFilters;
